// Floor API functions
import { getData, deleteData, postData, putData } from '../apiClient';

// Get floors with pagination
export const getHolidayWithPagination = async ({ page = 1, limit = 10, search = '' }, signal = null) => {
    try {
        const queryParams = new URLSearchParams({
            page: String(page),
            limit: String(limit),
            search: search
        });

        const result = await getData(`/holiday/?${queryParams}`, {}, {}, signal);
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error('Get holidays API error:', error);
        return {
            data: {
                success: false,
                error: error.message,
                data: [],
                totalPages: 1,
                prevPage: false,
                nextPage: false,
                totalDocs: 0,
                page: 1
            }
        };
    }
};

// Get single holiday by ID
export const getHolidayById = async (id) => {
    try {
        const result = await getData(`/holiday/${id}`);
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error('Get holiday by ID API error:', error);
        return {
            data: {
                success: false,
                error: error.message,
                data: null
            }
        };
    }
};

// Create new holiday
export const createHoliday = async ({ data }) => {
    try {
        const result = await postData("/holiday/create-holiday", data);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Create holiday API error:", error);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.data.error : error.message,
                status: error.status,
            },
        };
    }
};

// Update holiday
export const updateHoliday = async ({ id, data }) => {
    try {
        const result = await putData(`/holiday/update-holiday/${id}`, data);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error('Update holiday API error:', error);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.data.error : error.message,
                status: error.status,
            },
        };
    }
};

// Delete holiday
export const deleteHoliday = async ({ id }) => {
    try {
        const result = await deleteData(`/holiday/delete-holiday/${id}`);
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error('Delete holiday API error:', error);
        return {
            data: {
                success: false,
                error: error.message,
                data: null
            }
        };
    }
};